// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"cf09f3d6","42":"a96ce490","149":"fd34e05c","232":"bd6a384f","445":"a3b363be","464":"67cdbdc1","550":"b2d660ad","571":"5869a0ae","605":"2a217d9f","644":"712682c8","722":"17aca620","970":"851a8ec1","981":"8e2b0481"}[chunkId] + ".js";
};